import {AxiosResponse} from "axios";
import React from "react";
import {RouteComponentProps, withRouter} from "react-router-dom";
import {HttpError} from "../../../../common/components/shared/httpError/httpError";
import Loader from "../../../../common/components/shared/loader/loader";
import {HttpErrorModel} from "../../../../common/models/httpError";
import {RouteParamsModel} from "../../../../common/models/routeParams";
import {Api} from "../../../../helpers/api";
import i18n from "../../../../i18n/i18n";
import {RouteModel} from "../../../models/route";
import {RouteService} from "../../../services/routeService";
import RouteForm from "../routeForm/routeForm";

interface ModifyRouteState {
    routeData?: RouteModel | null;
    response: AxiosResponse<HttpErrorModel[] | any> | undefined;
}

class ModifyRoute extends React.Component <RouteComponentProps, ModifyRouteState> {
    constructor(props: any) {
        super(props);

        this.state = {
            routeData: null,
            response: undefined
        };
    }

    private get routeData() {
        return this.state.routeData;
    }

    public async componentDidMount() {
        const params = this.props.match.params as RouteParamsModel;
        const response = await RouteService.getRoute(params.id);

        this.setState({response});

        if (Api.isSuccess(response)) {
            this.setState({
                routeData: response?.data || null
            });
        }
    }

    public render(): JSX.Element {
        return (
            <div className="modify-route modify-record">
                <div className="content">
                    <div className="header">
                        {i18n.t("topology.routes.actions.modifyRoute.header")}
                    </div>
                    {this.renderContent()}
                </div>
            </div>
        );
    }

    private renderContent(): JSX.Element {
        if (!Api.isSuccess(this.state.response)) {
            return <HttpError
                response={this.state.response}
                cause={i18n.t("topology.routes.errors.selectedRouteErrorSuffix")}
            />;
        } else if (this.routeData) {
            return <RouteForm isUpdate={true} routeData={this.routeData}/>;
        } else {
            return (
                <Loader/>
            );
        }
    }
}

export default withRouter(ModifyRoute);